import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html'
})
export class AppSidebarComponent { }



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/components/app-sidebar/app-sidebar.component.ts